var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"pagefra",staticStyle:{"height":"100%"}},[(!_vm.$store.state.pageScroll.scroll && !_vm.$store.state.siderConfig.isHide)?_c('pagesider'):_vm._e(),_c('el-container',{staticClass:"pagefra-main",staticStyle:{"height":"100%"}},[_c('pageheader'),_c('page-tabs'),_c('el-main',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }